export default __webpack_public_path__ + "static/media/oo.c9627742.gif";